import { render, staticRenderFns } from "./SalesControlTable.vue?vue&type=template&id=59760895&scoped=true&"
import script from "./SalesControlTable.vue?vue&type=script&lang=js&"
export * from "./SalesControlTable.vue?vue&type=script&lang=js&"
import style0 from "./SalesControlTable.vue?vue&type=style&index=0&id=59760895&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59760895",
  null
  
)

export default component.exports